import React from "react";
import { Link } from "react-router-dom";
import "./cta.css";

function CTA() {
  return (
    <section className="cta-section">
      <div className="container">
        <h1 className="sub-heading">ยินดีต้อนรับสู่่สมาคมนวัตกรรมสิ่งแวดล้อม</h1>
        <p className="cta-text">
          {/* Lorem Ipsum is simply dummy text of the printing and typesetting
          industry. Lorem Ipsum has been the industry's standard dummy text ever
          since the 1500s. */}
        </p>
        <div className="cta-buttons">
          <Link to="/about-us" className="cta-button">
            ABOUT US
          </Link>
          <Link to="/contact" className="cta-button">
            CONTACT US <span className="arrow">→</span>
          </Link>
        </div>
      </div>
    </section>
  );
}

export default CTA;
